import img1 from '../assets/images/Scrollbar01.PNG';

export const scrollbarData = [
  {
    icon: img1,
    title: "Choose from our menu of rice and curry combinations",
    content:
      "We use only the freshest ingredients & traditional recipes to ensure each dish is a masterpiece",
  },
  {
    icon: img1,
    title: "Customize your order to your taste preferences (Coming Soon)", 
    content:
      "We use only the freshest ingredients & traditional recipes to ensure each dish is a masterpiece",
  },
];